import React, {Dispatch, SetStateAction, useEffect, useState} from 'react';
import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Typography} from '@mui/material';
import { closeBtn, dialogActions, dialogTitle, paperProps, title ,secondaryText, mainText} from './AccountsAddModal.sx';
import CloseIcon from 'app/components/Icons/CloseIcon';
import SuccessModal from 'app/components/SuccessModal';
import CustomSwitch from "app/components/CustomSwitch";
import {grey10} from "app/components/ThemeProvider/colors";

interface Props {
    open: boolean;
    close: Dispatch<SetStateAction<boolean>>;
    handleSubmit?:() => void;
    accountData: any[];
}

const AccountsAddModal = (props: Props) => {
    const { open, close,handleSubmit,accountData } = props;
    const [successModal, setSuccessModal] = useState(false);
    const [unSuccessModal, setUnSuccessModal] = useState(false);

    return (
        <>
            <Dialog
                open={open}
                PaperProps={{
                    sx: paperProps,
                }}
                onClose={() => {close(false);}}
            >
                <DialogTitle sx={{ ...dialogTitle }}>
                    <Box sx={{display: 'flex',flexDirection: 'column',gap: '12px'}}>
                        <Typography sx={title}>Hesab əlavə et</Typography>
                    </Box>
                    <Button
                        color={'secondary'}
                        onClick={() => {
                            close(false);
                        }}
                        sx={closeBtn}
                    >
                        <CloseIcon />
                    </Button>
                </DialogTitle>
                <DialogContent sx={{maxHeight: '260px',p: '36px 36px 0px 36px',mt: '42px' }}>
                    {accountData?.map((item: any, index: number) => (
                        <Box key={index} sx={{display: 'flex',gap: '20px',flexDirection: 'column'}}>

                            <Box sx={{display: 'flex',gap: '4px',flexDirection: 'column',marginTop: '20px'}}>
                                <Typography sx={mainText}>{item.productName}</Typography>
                                <Typography sx={secondaryText}>{item.iban}</Typography>
                            </Box>
                            {index !== accountData?.length-1 && <Divider/>}
                        </Box>
                    ))}
                </DialogContent>
                <DialogActions sx={dialogActions}>
                    <Box sx={{display: 'flex', flexDirection: 'column'}}>
                        <Box sx={{display: 'flex',gap: '8px',flexDirection: 'column',p: '20px',borderRaduis:'10px',backgroundColor: grey10}}>
                            <CustomSwitch title={'Əsas hesab et'}/>
                            <Typography sx={secondaryText}>Seçilmis hesab əsas hesab kimi təyin ediləcək.</Typography>
                        </Box>
                        <Box sx={{display: 'flex',flexDirection: 'row',alignItems: 'center',gap: '12px',mt: '30px'}}>
                            <Button
                                onClick={() => {

                                }}
                            >
                                Əlavə et
                            </Button>
                            <Button

                                color={'secondary'}
                                sx={{ ml: '0 !important'}}
                                onClick={() => {
                                    close(false);
                                    // setUnSuccessModal(true);

                                }}
                            >
                                İmtina
                            </Button>
                        </Box>
                    </Box>
                </DialogActions>
            </Dialog>
            <SuccessModal open={successModal} close={setSuccessModal} successText={'Sorğunuz uğurla göndərildi!'} />
            <SuccessModal unsuccess={true} open={unSuccessModal} close={setUnSuccessModal} successText={'Sorğunun göndərilməsində xəta baş verdi!'} />
        </>
    );
};

export default AccountsAddModal;
